import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import Style from './MapFloatPanel.module.less';

const MapFloatPanel = (props) => {
  const { children, top, right, bottom, left, zIndex, sx, ...rest } = props;

  return (
    <Box className={Style.Root} sx={{ top, right, bottom, left, zIndex, ...sx }} {...rest}>
      {children}
    </Box>
  );
};

MapFloatPanel.propTypes = {
  zIndex: PropTypes.number,
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
};

export default memo(MapFloatPanel);
